export default __webpack_public_path__ + "static/media/pf.edf5258c.svg";